module.exports = __webpack_public_path__ + "static/media/mc_eject_rotor.eb5d64fb.svg";